<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <div class="modal-header">
        <h5 class="modal-header-title">{{ adminText(&quot;shellAll.what_s_new_question&quot;, &quot;What's new?&quot;) }}</h5>
        <main-button class="back-btn" flat :text="adminText(&quot;shellAll.skip&quot;, &quot;SKIP&quot;)" @click="$emit('closeModal')" />
      </div>
      <div class="modal-main-container">
        <onboarding-modal-info
          :key="dashboardNewsScreensInfo[focusedScreenIndex].id"
          :onboarding-info="dashboardNewsScreensInfo[focusedScreenIndex]"
        />
      </div>
      <div class="buttons">
        <div class="back-btn-container">
          <main-button
            v-if="focusedScreenIndex > 0"
            class="back-btn"
            flat
            @click="previousScreen()"
          >
            <v-icon medium class="back-icon" color="#0277BD"> arrow_back </v-icon>
          </main-button>
          <div v-else />
        </div>
        <div class="screen-number-container">
          <div class="screen-number-text">{{ focusedScreenIndex + 1 }}/{{ totalScreensCount }}</div>
        </div>
        <div class="continue-btn-container">
          <main-button
            v-if="focusedScreenIndex === totalScreensCount - 1"
            class="continue-btn"
            :text="adminText(&quot;shellAll.done&quot;, &quot;done&quot;)"
            depressed
            @click="$emit('closeModal')"
          />
          <main-button v-else class="continue-btn" depressed outline @click="nextScreen()">
            <span>{{ adminText(&quot;shellAll.next&quot;, &quot;NEXT&quot;) }}</span>
            <v-icon class="arrow">arrow_forward</v-icon>
          </main-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { frontendURL } from '../../../utils'
import onboardingModalInfo from './onboarding-modal-info.vue'

export default {
  mixins: [AdminContext],
  name: 'dashboard-news-modal',
  components: { onboardingModalInfo },
  data() {
    return { focusedScreenIndex: 0 }
  },
  computed: {
    dashboardNewsScreensInfo() {
      return [
        {
          id: 1,
          imageUrl: `${frontendURL}/assets/dashboard-news/slide-1-placeholder.png`,
          title: this.adminText('shellAll.r1_invoice_notifications', 'R1 Invoice Notifications'),
          description:
          this.adminText('shellAll.you_will_now_receive_an_email_notification_for_every_r1_invoice_request_this_ensures_you_can_process_business_orders_promptly_as_they_arrive', 'You will now receive an email notification for every R1 invoice request. This ensures you can process business orders promptly as they arrive.'),
        },
        {
          id: 2,
          imageUrl: `${frontendURL}/assets/dashboard-news/slide-2-placeholder.png`,
          title: this.adminText('shellAll.centralized_r1_documentation', 'Centralized R1 Documentation'),
          description:
          this.adminText('shellAll.all_r1_requests_for_a_specific_event_are_now_gathered_in_one_place_you_can_find_the_complete_list_and_customer_details_under_the_documentation_tab_within_your_event_dashboard', 'All R1 requests for a specific event are now gathered in one place. You can find the complete list and customer details under the Documentation tab within your event dashboard.'),
        },
        {
          id: 3,
          imageUrl: `${frontendURL}/assets/dashboard-news/slide-3-placeholder.png`,
          title: this.adminText('shellAll.fiscalization_2_0_compliance_2026', 'Fiscalization 2.0 Compliance (2026)'),
          description:
          this.adminText('shellAll.starting_in_2026_new_regulations_under_fiscalization_2_0_require_event_organizers_to_issue_and_fiscalize_r1_invoices_through_their_own_systems_as_we_sell_tickets_in_your_name_and_for_your_account_please_ensure_your_accounting_department_is_ready_for_this_change', 'Starting in 2026, new regulations under Fiscalization 2.0 require event organizers to issue and fiscalize R1 invoices through their own systems. As we sell tickets in your name and for your account, please ensure your accounting department is ready for this change.'),
        },
      ]
    },
    totalScreensCount() { return this.dashboardNewsScreensInfo.length },
  },
  methods: {
    nextScreen() {
      this.focusedScreenIndex += 1
    },
    previousScreen() {
      this.focusedScreenIndex -= 1
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  height: fit-content;
  max-height: 90vh;
  width: 100%;
  position: relative;
  max-width: 34.313rem;
  border-radius: 16px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 16px #33333329;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
}
.modal-header-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.modal-main-container {
  padding: 0 2rem;
  flex: 1;
  display: flex;
  align-items: center;
}
.buttons {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 1.5rem;
}
.back-btn-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.continue-btn-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.screen-number-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.screen-number-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #666666;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
}
</style>
